//
//
//
//
//
//

// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import { merchantCityRegionTree } from '@/api/user';
export default {
  name: 'App',
  created: function created() {
    merchantCityRegionTree().then(function (res) {
      localStorage.setItem('merchantCityRegionTree', JSON.stringify(res));
    });
  }
};